module.exports = __webpack_public_path__ + "img/9788983926128.6482eea3.jpg";